import luhn_validate from '../validation-helpers/LuhnValidate'

export const printIhiNumber = (ihiNumber: string) => {
  if (!luhn_validate(ihiNumber, 16)) {
    return null
  }

  return (ihiNumber.match(/(.{1,4})/g) ?? []).join(' ')
}
